import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';

import cutOut from './components/cutOut.js';
import dynamicFontSize from './components/dynamicFontSize.js';
import embed from './components/embed.js';
import menu from './components/menu.js';
import siema from './components/siema.js';
import toggles from './components/toggles.js';
import stickyMedia from './components/stickyMedia.js';

cutOut.init();
dynamicFontSize.init();
embed.init();
menu.init();
siema.init();
toggles.init();
stickyMedia.init();
